export default "__VITE_ASSET__CFBTaxz6__"